import ReactDOM from 'react-dom'
import React from 'react'
import { ReflexElement } from 'react-reflex'

class ControlledElementBase extends React.Component {
  constructor() {
    super()
    this.onMinimize = this.onMinimize.bind(this)
    this.onMaximize = this.onMaximize.bind(this)

    this.state = {
      size: -1,
    }
  }

  onMinimize() {
    const minSize = this.props.minSize
    const currentSize = this.getSize()
    const update = size => {
      return new Promise(resolve => {
        this.setState(
          Object.assign({}, this.state, {
            size: size < minSize ? minSize : size,
          }),
          () => resolve()
        )
      })
    }
    const done = (from, to) => from < to
    this.animate(currentSize, minSize, -this.props.step, done, update)
  }

  onMaximize() {
    const currentSize = this.getSize()
    const update = size => {
      return new Promise(resolve => {
        this.setState(
          Object.assign({}, this.state, {
            size,
          }),
          () => resolve()
        )
      })
    }
    const done = (from, to) => from > to

    this.animate(currentSize, this.props.offsetOnMaximize, this.props.step, done, update)
  }

  getSize() {
    const domElement = ReactDOM.findDOMNode(this)
    switch (this.props.orientation) {
      case 'horizontal':
        return domElement.offsetHeight
      case 'vertical':
        return domElement.offsetWidth
      default:
        return 0
    }
  }

  animate(from, to, step, done, fn) {
    const stepFn = () => {
      if (!done(from, to)) {
        fn((from += step)).then(() => {
          setTimeout(stepFn, 8)
        })
      }
    }
    stepFn()
  }

  componentDidMount() {
    if (this.props.show) {
      this.onMaximize()
    } else {
      this.onMinimize()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.show !== prevProps.show) {
      if (this.props.show && this.getSize() <= this.props.minSize) {
        this.onMaximize()
      } else if (!this.props.show) {
        this.onMinimize()
      }
    }
  }

  render() {
    const { children, forwardedRef, ...rest } = this.props
    return (
      <ReflexElement size={this.state.size} ref={forwardedRef} {...rest}>
        {children}
      </ReflexElement>
    )
  }
}

export const ControlledElement = React.forwardRef((props, ref) => {
  return <ControlledElementBase {...props} forwardedRef={ref} />
})

ControlledElementBase.defaultProps = {
  step: 25,
  offsetOnMaximize: 300,
  show: true,
}
